import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Link, useNavigate } from 'react-router-dom';
import SampleTemplate from "../assets/documents/samplequestionfile.xlsx";
import Swal from "sweetalert2";
import { GetJobRoles, GetTestTypes, AddQuestions_BulkImport } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";
const Addbulkquestions = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const {selectedCountry} = useCountry();
  useEffect(() => {
    fetchJobRoles();
    fetchTestTypes(); 
  }, [selectedCountry]);

  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const roleID = localStorage.getItem("roleID")
  const token = localStorage.getItem("jwtToken");
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  const fetchJobRoles = async () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
    return await axios.get(getApiUrl)
      .then((response) => {
        return response.data; // Return the data from the response
      })
      .catch((error) => {
        console.error("Error fetching job roles", error);
        throw error; // Re-throw the error to be caught in the calling function
      });
  };

  const fetchTestTypes = async () => {
    const getTestTypesUrl = GetTestTypes.APIURL;
    return await axios.get(getTestTypesUrl,{headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        return response.data; // Return the data from the response
      })
      .catch((error) => {
        console.error("Error fetching test types", error);
        throw error; // Re-throw the error to be caught in the calling function
      });
  };
  

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  
  const handleImport = async () => {
    if (!file) {
      setError("Please select a file.");
      return;
    }
  
    setLoading(true);
    setError(null);
  
    try {
      // Read the Excel file
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
   
  
      // Fetch job roles and test types concurrently
      const [jobRolesResponse, testTypesResponse] = await Promise.all([fetchJobRoles(), fetchTestTypes()]);
  
    
      const formattedData = jsonData.map((item) => {
        const jobRole = jobRolesResponse.find(role => role.jobRole == item.jobRole);
        const testType = testTypesResponse.find(type => type.testType == item.testTypes);
      
        return {
          jobRoleID: jobRole ? jobRole.jobRoleId : null,
          testTypeID: testType ? testType.testTypeID : null,
          Question: item["question"],
          answer:item["answer"],
          createdBy: email,
          userGuid: Guid,
          countryID:selectedCountry

        };
      });
      
  
      const response = await axios.post(
        AddQuestions_BulkImport.APIURL,
        formattedData,{ headers: { Authorization: `Bearer ${token}` } }
      );
  
      if (response.data.message === 'Record created successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Added Successfully',
          showConfirmButton: false,
          timer: 5000
        });
        navigate("/Employer/Questions");
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Add correct File',
          showConfirmButton: false,
          timer: 5000
        });
      }
  
      setLoading(false);
    } catch (error) {
      console.error("Import error:", error);
      setError("Error occurred during import. Please try again.");
      setLoading(false);
    }
  };
  
  
  
  

  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
          <div className="row">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Link to="/Employer/Questions">
                  <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
                </Link>
                <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Import Questions</h2>
              </div>
            </div>
            <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3'>
              <div style={{ float: "right" }}>
                  <a href={SampleTemplate} download="SampleFile.xlsx">
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Sample Questions Template</Tooltip>)}>

                    <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-download"></i></button>
                    </OverlayTrigger>   </a>
                
              </div>
            </div>
          </div>
          <hr />
          <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
            <div className="row mt-2">
              <div className="">
                <div className="" style={{ background: "#f8f8f8" }}>
                  <div className="d-flex">
                    <div>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Upload Excel File</Tooltip>)}>
                        <input type="file" className="form-control" onChange={handleFileChange} />
                      </OverlayTrigger>
                    </div>
                    {error && <div className="invalid-feedback">{error}</div>}
                    <button style={{ marginLeft: 15 }} onClick={handleImport} className="btn btn-primary">
                      {loading ? "Importing..." : "Import"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ConsultantLayout>
  );
};

export default Addbulkquestions;
